export default {
  team_term: 'equipos',
  days_until_start:
    '%{smart_count} día hasta que comience la campaña |||| %{smart_count} días hasta que comience la campaña',
  now_over: 'Esta campaña ha terminado',
};
